import React from "react";

const LashesExtensionQuestion = () => {
  return (
    <div className="blogBenefits-content">
      <h3>Common Questions About Eyelash Extensions</h3>
      <li>
        <h6>1. Are Eyelash Extensions Safe for Women with Sensitive Eyes?</h6>
        <p>
          Yes! A professional lash technician will use hypoallergenic adhesive
          and customize the application to minimize irritation. Be sure to
          mention any sensitivities during your consultation.
        </p>
      </li>
      <li>
        <h6>2. How Long Do Eyelash Extensions Last?</h6>
        <p>
          Eyelash extensions typically last 4-6 weeks, depending on your natural
          lash cycle and how well you care for them. For special occasions, you
          can maintain them longer with proper aftercare and regular refills.
        </p>
      </li>{" "}
      <li>
        <h6>3. Can I Wear Eye Makeup with Eyelash Extensions?</h6>
        <p>
          Yes, but avoid oil-based makeup and waterproof mascara, as these can
          weaken the adhesive. Opt for lash extension-friendly products.
        </p>
      </li>{" "}
      <li>
        <h6>4. Do Eyelash Extensions Damage Natural Lashes?</h6>
        <p>
          When applied and maintained correctly, eyelash extensions do not
          damage your natural lashes. Ensure you visit a certified technician
          for safe application.
        </p>
      </li>
    </div>
  );
};

export default LashesExtensionQuestion;
